export default "__VITE_ASSET__BO$SXte0__"